const VIEWPORT_MARGIN = 8;

interface GetPanelOffsetTopArgs {
  buttonTop: number;
  menuTop: number;
  panelHeight: number;
  viewportHeight: number;
}

export const getPanelOffsetTop = ({
  buttonTop,
  menuTop,
  panelHeight,
  viewportHeight,
}: GetPanelOffsetTopArgs): number => {
  const alignedTop = buttonTop - menuTop;

  if (panelHeight === 0) {
    return alignedTop;
  }

  const minTop = VIEWPORT_MARGIN - menuTop;
  const maxTop = viewportHeight - VIEWPORT_MARGIN - panelHeight - menuTop;

  return Math.round(Math.min(alignedTop, Math.max(minTop, maxTop)));
};
